import { connect } from 'react-redux';
import UserRoleDetailView from './UserRoleDetailView.jsx';
import { showSettingsSideMenu, hideSettingsSideMenu }
  from 'src/legacy/redux/actions/settings.jsx';
import { fetchUserRole, createUserRole, updateUserRole, fetchUserRolesForAccount, deleteUserRole } from 'src/legacy/redux/actions/userRoles';
import _ from 'lodash';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  var id = ownProps.params.id;
  return {
    userRoles: _.get(state, 'legacyRootReducer.userRoles.items', []),
    userRole: _.get(state, 'legacyRootReducer.userRoles.userRole.item', []),
    loading: _.get(state, 'legacyRootReducer.userRoles.userRole.loading', false),
    creating: _.get(state, 'legacyRootReducer.userRoles.creating', false),
    deleting: _.get(state, 'legacyRootReducer.userRoles.deleting', false),
    updating: _.get(state, 'legacyRootReducer.userRoles.userRole.updating', false),
    account: _.get(state, 'accounts', {})
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showSettingsSideMenu: () => {
      dispatch(showSettingsSideMenu());
    },

    hideSettingsSideMenu: () => {
      dispatch(hideSettingsSideMenu())
    },

    fetchUserRole: (id) => {
      return dispatch(fetchUserRole(id));
    },

    createUserRole: (request) => {
      return dispatch(createUserRole(request));
    },

    updateUserRole: (id, request) => {
      return dispatch(updateUserRole(id, request));
    },

    fetchUserRolesForAccount: () => {
      return dispatch(fetchUserRolesForAccount());
    },

    deleteUserRole: (id) => {
      return dispatch(deleteUserRole(id));
    }
  }
}

const UserRoleDetailPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserRoleDetailView);

export default withUseHooks(UserRoleDetailPage);